// @flow
import styled, { css } from "styled-components"

export const AvatarWrap = styled.div`
  width: 4rem;
  height: 4rem;
  letter-spacing: 0.04rem;
  line-height: 4rem;
  text-align: center;
  border-radius: 100%;
  background-color: ${(props) => props.theme.color.lightGray};
  color: ${(props) => props.theme.color.white};
  font-weight: ${(props) => props.theme.fontWeights.bold};
  text-transform: uppercase;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;

  ${p =>
    p.big &&
    css`
      width: 8rem;
      height: 8rem;
      letter-spacing: 0.08rem;
      line-height: 8rem;
      font-size: 2.6rem;
      margin-bottom: 2rem;
    `}
`



// WEBPACK FOOTER //
// ./src/components/Avatar/styled.js